module.exports = __webpack_public_path__ + "static/media/bm.babc72fc.svg";